import React, { Component } from 'react';
import Dashboard2 from '../dashboard2';
import DashboardLegacy from '../dashboardLegacy';

export const DASHBOARD_UI_KEY = 'dashboardUi';

export function getDashboardUiMode() {
  try {
    return localStorage.getItem(DASHBOARD_UI_KEY) === 'old' ? 'old' : 'new';
  } catch (e) {
    return 'new';
  }
}

export function setDashboardUiMode(mode) {
  try {
    localStorage.setItem(DASHBOARD_UI_KEY, mode === 'old' ? 'old' : 'new');
  } catch (e) {
    // ignore
  }
}

/**
 * Renders New (React/MUI) or Old (iframe) dashboard based on localStorage,
 * and passes onSwitchUi so each view can toggle.
 */
class DashboardGate extends Component {
  state = {
    mode: getDashboardUiMode(),
  };

  handleSwitchUi = (mode) => {
    const next = mode === 'old' ? 'old' : 'new';
    setDashboardUiMode(next);
    this.setState({ mode: next });
  };

  render() {
    const { mode } = this.state;
    if (mode === 'old') {
      return <DashboardLegacy onSwitchUi={this.handleSwitchUi} />;
    }
    return <Dashboard2 onSwitchUi={this.handleSwitchUi} />;
  }
}

export default DashboardGate;



// WEBPACK FOOTER //
// ./src/components/dashboardGate/index.js